/**
 * Mock dataset IDs as valid UUIDs for DeID demo/dev flows.
 * Used so payload.dataset_id can be stored in deid_session_documents.dataset_id (UUID column).
 * Same IDs must be used in server and client mock dataset lists.
 */
export const MOCK_DATASET_IDS = {
    /** Single Text File Test (client id '5') / John Davies ICU (server id '1' uses same payload type) */
    MOCK_1: '11111111-1111-4111-8111-111111111101',
    /** Single Text File Test Dataset (client) */
    MOCK_5: '11111111-1111-4111-8111-111111111105',
    /** Single DICOM Image Test Dataset */
    MOCK_6: '11111111-1111-4111-8111-111111111106',
    /** Mixed Text and DICOM Test Dataset */
    MOCK_7: '11111111-1111-4111-8111-111111111107',
    /** IDs-based Text De-identification Test Dataset */
    MOCK_8: '11111111-1111-4111-8111-111111111108',
    /** ES Document IDs Mock Dataset (fetch from Elasticsearch) */
    MOCK_9: '11111111-1111-4111-8111-111111111109',
} as const;

export const MOCK_DATASET_IDS_LIST: string[] = Object.values(MOCK_DATASET_IDS);

/** ID for "dataset 9" - when this is selected, backend may fetch document IDs from ES */
export const MOCK_DATASET_ES_FETCH_ID = MOCK_DATASET_IDS.MOCK_9;

export function isMockDatasetId(id: string | undefined | null): boolean {
    return !!id && MOCK_DATASET_IDS_LIST.includes(id);
}

/** Numeric key for payload logic (1,5,6,7,8,9) */
export function getMockDatasetNumericKey(id: string): '1' | '5' | '6' | '7' | '8' | '9' | null {
    switch (id) {
        case MOCK_DATASET_IDS.MOCK_1:
            return '1';
        case MOCK_DATASET_IDS.MOCK_5:
            return '5';
        case MOCK_DATASET_IDS.MOCK_6:
            return '6';
        case MOCK_DATASET_IDS.MOCK_7:
            return '7';
        case MOCK_DATASET_IDS.MOCK_8:
            return '8';
        case MOCK_DATASET_IDS.MOCK_9:
            return '9';
        default:
            return null;
    }
}
